import $ from 'jquery'
import rpcCall from "./util/rpc/rpcCalls";

$(document).ready(function () {
    let $navTable = $('.navTable')
    let toggleNavSubmenuDropdownListeners = (navigationCollapsed) => {
        let $containers = $navTable.find('.popup_submenu_container')

        if (navigationCollapsed) {
            $containers.each((_, element) => {
                let $el = $(element)
                let $menuBody = $el.find('.popup_menu_body')
                $el.click((event) => { event.stopPropagation() })
                $el.mouseenter((event) => { window.PopupMenu.show(event, $menuBody) })
                $el.mouseleave(() => { window.PopupMenu.hide_all() })
            });
        } else {
            $containers.each((_, element) => {
                $(element)
                    .unbind("click")
                    .unbind("mouseenter")
                    .unbind("mouseleave")
            });
        }
    }

    $('.collapsCell').on('click', () => {
        $navTable.toggleClass('collapsed')
        window.NAVIGATION_COLLAPSED = !window.NAVIGATION_COLLAPSED
        let newNavigationCollapsed = window.NAVIGATION_COLLAPSED

        toggleNavSubmenuDropdownListeners(newNavigationCollapsed)

        $(document).trigger("navigation_resize_event", {navigationCollapsed: newNavigationCollapsed})

        rpcCall("UserGlobalSettingsService.saveNavigationCollapsed", [newNavigationCollapsed], () => true)
    })

    toggleNavSubmenuDropdownListeners(window.NAVIGATION_COLLAPSED)
})



// WEBPACK FOOTER //
// ./web/js/navigation_resize.js